var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button outline",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.copyValue.apply(null, arguments)}}},[(_vm.copied)?_c('span',[_vm._v(_vm._s(_vm.copiedText))]):_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }